export const environment = {
  production: false,
  apiSegmentUrl: 'https://winninghandsapi.co3.xyz',
  apiBaseUrl: 'https://winninghandsapi.co3.xyz',
  loginUrl: 'login',
};
